import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-with-circle-text',
  templateUrl: './image-with-circle-text.component.html',
  styleUrls: ['./image-with-circle-text.component.css']
})
export class ImageWithCircleTextComponent {
  @Input() data!:any;
  
}
